<template>
  <container v-if="content" :hidden="!ready" :class="['md-section']" v-html="content" />
</template>
<script>
import marked from 'marked'

export default {
  name: 'MdSection',
  data () {
    return {
      content: null,
      ready: false
    }
  },
  props: {
    md: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.getMd()
  },
  methods: {
    getMd () {
      this.$http({
        url: `${this.$root.config.staticAssetsDir}/md/${this.md}`
      }).then(md => {
        if (md.status === 200 && md.data) {
          this.content = marked(md.data)
          this.$nextTick(() => {
            this.format()
          })
        }
      }).catch(error => {
        console.error(error)
      })
    },
    format () {
      this.select('h1').forEach(item => {
        item.classList.add('text-3xl', 'mb-3')
      })
      this.select('a').forEach(item => {
        item.classList.add('underline')
      })
      this.select('h2').forEach(item => {
        item.classList.add('text-2xl', 'mb-3')
      })
      this.select('h3').forEach(item => {
        item.classList.add('text-xl', 'mb-2')
      })
      this.select('hr').forEach(item => {
        item.classList.add('mb-3')
      })
      this.select('h4').forEach(item => {
        item.classList.add('text-base', 'mb-3')
      })
      this.select('h5, h6, p, ul, ol, div, span, pre, code, table').forEach(item => {
        item.classList.add('text-sm', 'mb-3')
        if (['OL', 'UL'].includes(item.tagName)) {
          item.classList.add('list-disc', 'list-inside')
        }
      })
      this.ready = true
    },
    select (selectors = '') {
      return this.$el.querySelectorAll(selectors)
    }
  }
}
</script>
<style>
.md-section li ul
{
  margin-left: 1.5em;
}

.md-section code
{
  color: initial;
  box-shadow: initial;
  text-shadow: initial;
}

.md-section *
{
  user-select: initial;
  pointer-events: all;
}

.md-section pre
{
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/md-section.vue